import { defineStore } from 'pinia';

/**
 * Store for managing site-wide banners.
 */
export const useBannersStore = defineStore('banners', {
    state: () => ({
        showSignalRConnectionFailedBanner: false,
        showPushNotificationErrorBanner: false,
        showSensorDisabledBanner: false,
        showSubscribeBanner: false,
        showReconnectingBanner: false,
        showInitializeResourcesErrorBanner: false
    }),
    actions: {
        /**
         * Resets the state to its default values.
         */
        resetState() {
            this.$reset();
        },
        /**
         * Shows the signalR connection failed banner.
         */
        displaySignalRConnectionFailedBannerAction() {
            this.showSignalRConnectionFailedBanner = true;
        },
        /**
         * Hides the signalR connection failed banner.
         */
        dismissSignalRConnectionFailedBannerAction() {
            this.showSignalRConnectionFailedBanner = false;
        },
        /**
         * Shows the push notification error banner.
         */
        displayPushNotificationErrorBannerAction() {
            this.showPushNotificationErrorBanner = true;
        },
        /**
         * Hides the push notification error banner.
         */
        dismissPushNotificationErrorBannerAction() {
            this.showPushNotificationErrorBanner = false;
        },
        /**
         * Shows the sensor disabled banner.
         */
        displaySensorDisabledBannerAction() {
            this.showSensorDisabledBanner = true;
        },
        /**
         * Hides the sensor disabled banner.
         */
        dismissSensorDisabledBannerAction() {
            this.showSensorDisabledBanner = false;
        },
        /**
         * Shows the subscribe banner.
         */
        displaySubscribeBannerAction() {
            this.showSubscribeBanner = true;
        },
        /**
         * Hides the subscribe banner.
         */
        dismissSubscribeBannerAction() {
            this.showSubscribeBanner = false;
        },
        /**
         * Shows the reconnecting banner.
         */
        displayReconnectingBannerAction() {
            this.showReconnectingBanner = true;
        },
        /**
         * Hides the reconnecting banner.
         */
        dismissReconnectingBannerAction() {
            this.showReconnectingBanner = false;
        },
        /**
         * Shows the resource initialize error banner.
         */
        displayInitializeResourcesErrorBannerAction() {
            this.showInitializeResourcesErrorBanner = true;
        },
        /**
         * Hides the resource initialize error banner.
         */
        dismissInitializeResourcesErrorBannerAction() {
            this.showInitializeResourcesErrorBanner = false;
        }
    }
});
